import { Panel } from "primereact/panel";
import * as generic from "../../../../../components/Generico";
import { Divider } from "primereact/divider";
import { DomicilioFiscalClientePj } from "../../../../../models/trust/clientepj/DomicilioFiscalClientePj"; // <-- NUEVO MODELO
import { useForm } from "react-hook-form";
import { ClientePjService } from "../../../../../service/trust/ClientePjService";
import { InputComponent } from "../../../../../components/InputComponent";
import { useEffect, useState } from "react";
import { ProgressSpinner } from "primereact/progressspinner";
import { useSubmitForm } from "../../../../../hooks/useSubmitForm";
import { BottomActionBar } from "../../../../../components/ui/BottomActionBar";

export const DomicilioFiscal = ({ toast, id, permss, handlePrev, nuevoCliente, setDialogAnexos, soloLectura }) => {

    const omodel = new DomicilioFiscalClientePj();
    const defaultValues = generic.funDefault(omodel.model);
    const { control, formState: { errors }, handleSubmit, reset, setError, setValue } = useForm({ defaultValues, shouldTrim: true });
    const clientePjServicio = new ClientePjService();
    const { inText, inDrop, downloadPdf } = InputComponent({ omodel, errors, control, permss, id, soloLectura });
    const { enviarFormulario } = useSubmitForm({
        toast, setError, onSuccess: (res) => {
            // Atrapamos la respuesta del backend y actualizamos el estado de la vista
            if (res?.data?.estado) {
                nuevoCliente({ nemonico: res.data.estado }); // En el flujo solo se envia 'ENVIADO'
            }
        }
    });

    const [isLoading, setIsLoading] = useState(true);
    const [load, setLoad] = useState(false);
    const [loadReport, setLoadReport] = useState(false);
    const [esEeuuFiscal, setEsEeuuFiscal] = useState(false);
    const [esExtranjeroFiscal, setEsExtranjeroFiscal] = useState(false);
    const [anexosRequisitos, setAnexosRequisitos] = useState([]);
    const [tieneCertificacionSociedades, setTieneCertificacionSociedades] = useState(false);

    useEffect(() => {
        if (id) {
            editFicha();
        } else {
            setIsLoading(false);
        }
        // eslint-disable-next-line
    }, [id]);

    const editFicha = () => {
        setIsLoading(true);
        clientePjServicio.consultarCliente(id, { seccion: 'seccion5' }).then(res => {
            if (res.data.anexos_requisitos !== undefined) {
                setAnexosRequisitos(res.data.anexos_requisitos);
            }
            setTieneCertificacionSociedades(res.data.tiene_certificacion_sociedades || false);
            const _cli = res.data.cliente;
            if (!_cli) {
                reset(defaultValues);
                setIsLoading(false);
                return;
            }

            setEsEeuuFiscal(_cli.eeuu_fin_fiscal?.cat_id === true);
            setEsExtranjeroFiscal(_cli.extranjero_fin_fiscal?.cat_id === true);

            reset(generic.renewValues(_cli, omodel.model));
        }).finally(() => setIsLoading(false));
    }

    const onSubmit = (data) => {
        setLoad(true);
        data.seccion = 'seccion5';
        data.id = id;

        clientePjServicio.editarCliente(data).then(res => {
            nuevoCliente({
                nemonico: res.data.nemonico,
                necesita_ac_sociedades: res.data.necesita_ac_sociedades
            });
            generic.funcSuccess(res, toast);
        }).catch(error => {
            generic.funcError(error, toast, setError);
        }).finally(() => setLoad(false));
    }

    const onError = () => {
        toast.current.show({ severity: 'error', summary: 'Error', detail: 'Revise los campos requeridos antes de guardar.', life: 3000 });
    }

    const onChangeEeuuFiscal = (e) => {
        const isEeuu = e.value?.cat_id === true;
        setEsEeuuFiscal(isEeuu);
        if (!isEeuu) setValue('eeuu_identificacion', '');
    }

    const onChangeExtranjeroFiscal = (e) => {
        const isExtranjero = e.value?.cat_id === true;
        setEsExtranjeroFiscal(isExtranjero);
        if (!isExtranjero) setValue('extranjero_identificacion', '');
    }

    const generarReporte = () => {
        setLoadReport(true);
        clientePjServicio.descargar(id).then(res => {
            downloadPdf(res, `${id}-Formulario-Informacion-Cliente-PJ.pdf`);
        }).catch(error => {
            generic.funcMessageBlobError('Complete la información antes de generar.', error, toast);
        }).finally(() => setLoadReport(false));
    }

    const subirReporte = () => { if (setDialogAnexos) setDialogAnexos(true); }

    const enviar = () => {
        enviarFormulario(id, 'ficha/trust/cliente-pj/enviar', 'clientePj');
    }

    if (isLoading) {
        return (
            <div className="flex flex-column align-items-center justify-content-center p-5">
                <ProgressSpinner style={{ width: '50px', height: '50px' }} strokeWidth="4" animationDuration=".5s" />
                <span className="mt-3 text-color-secondary font-medium text-lg">Consultando información...</span>
            </div>
        );
    }

    return (
        <>
            <form onSubmit={handleSubmit(onSubmit, onError)}>

                <Panel header={generic.renderPanelHeader('L', 'AUTORIZACIÓN DE ACCESO DE INFORMACIÓN', 'pi pi-lock')} className="panel-ficha shadow-1 mb-4">
                    <div className="field col p-3 text-justify line-height-3 text-700 bg-blue-50 border-round border-left-3 border-blue-500">
                        {omodel.msgAcceso}
                    </div>
                </Panel>

                <Panel header={generic.renderPanelHeader('M', 'DECLARACIÓN DE DOMICILIO FISCAL', 'pi pi-globe')} className="panel-ficha shadow-1 mb-4">
                    <div className="p-3 mb-3 text-justify line-height-3 text-800 bg-indigo-50 border-round border-left-3 border-indigo-500 mx-2 mt-2">
                        <div className="flex align-items-center gap-2 mb-2">
                            <i className="pi pi-exclamation-triangle text-indigo-600 text-lg"></i>
                            <span className="font-bold text-indigo-900">Importante</span>
                        </div>
                        <span>
                            Si responde <strong>"SÍ"</strong> a cualquiera de las siguientes preguntas sobre fines fiscales, deberá completar la <strong>Auto-certificación de Sociedades</strong> correspondiente.
                            <br className="hidden md:block" />
                            <span className="text-indigo-700 font-medium">
                                <i className="pi pi-info-circle mr-1 text-sm"></i>
                                Para acceder a ella, haga clic en <strong>Guardar</strong> y se habilitará una <strong>nueva pestaña</strong>.
                            </span>
                        </span>
                    </div>

                    <div className="formgrid grid p-2">
                        {inDrop('eeuu_fin_fiscal', generic.estadosSiNo, {
                            lab: 'nombre', chn: onChangeEeuuFiscal, val: true,
                            ne: tieneCertificacionSociedades ? true : undefined,
                            helpText: tieneCertificacionSociedades ? "No se puede editar este campo porque ya existe una auto-certificación generada para este cliente." : null
                        }, 4)}
                        {esEeuuFiscal && inText('eeuu_identificacion', { icon: 'pi pi-flag-fill' }, 8)}
                    </div>
                    <Divider type="dashed" />
                    <div className="formgrid grid p-2">
                        {inDrop('extranjero_fin_fiscal', generic.estadosSiNo, {
                            lab: 'nombre', chn: onChangeExtranjeroFiscal, val: true,
                            ne: tieneCertificacionSociedades ? true : undefined,
                            helpText: tieneCertificacionSociedades ? "No se puede editar este campo porque ya existe una auto-certificación generada para este cliente." : null
                        }, 4)}
                        {esExtranjeroFiscal && inText('extranjero_identificacion', { icon: 'pi pi-flag-fill', header: 'Indique País y Número de Identificación' }, 8)}
                    </div>
                </Panel>

                <Panel header={generic.renderPanelHeader('', 'DECLARACIÓN', 'pi pi-file-edit')} style={{ width: '100%', margin: 'auto' }} className="panel-ficha shadow-1 mb-4">
                    <div className="field col p-3 text-justify line-height-3 text-700 bg-blue-50 border-round border-left-3 border-blue-500">
                        <div className="flex align-items-center gap-2 mb-3">
                            <i className="pi pi-check-circle text-blue-600 text-lg"></i>
                            <span className="font-bold text-blue-900">Certificación de Veracidad y Reporte Fiscal</span>
                        </div>
                        {omodel.msgDeclaracion}
                    </div>
                </Panel>

                <Panel header={generic.renderPanelHeader('', 'AUTORIZACIÓN PARA TRATAMIENTO DE DATOS', 'pi pi-lock')} style={{ width: '100%', margin: 'auto' }} className="panel-ficha shadow-1 mb-4">
                    <div className="field col p-3 text-justify line-height-3 text-700 bg-blue-50 border-round border-left-3 border-blue-500">
                        <div className="flex align-items-center gap-2 mb-3">
                            <i className="pi pi-shield text-blue-600 text-lg"></i>
                            <span className="font-bold text-blue-900">Tratamiento de Datos Personales</span>
                        </div>
                        {omodel.msgTratamientoDatos}
                    </div>
                </Panel>

                <Panel header={generic.renderPanelHeader('', 'Anexos Requeridos', 'pi pi-paperclip')} style={{ width: '100%', margin: 'auto' }} className="panel-ficha shadow-1 mb-4">
                    <div className="field col p-3 text-justify line-height-3 text-700 bg-yellow-50 border-round border-left-3 border-yellow-500">
                        <div className="flex align-items-center gap-2 mb-3">
                            <i className="pi pi-file text-yellow-600 text-lg"></i>
                            <span className="font-bold text-yellow-900">Documentos requeridos</span>
                        </div>
                        <ul className="pl-4 m-0">
                            {anexosRequisitos.map((req, index) => (
                                <li key={index} className="mb-1">{req}</li>
                            ))}
                        </ul>
                    </div>
                </Panel>

                <BottomActionBar layoutVersion="v2" onPrev={handlePrev} onSave={true} onGenerate={() => generarReporte()} onSend={enviar} onAttachments={subirReporte} loading={load || loadReport}
                    isReadOnly={soloLectura} enableExtras={id != null} />
            </form>
        </>
    );
}